import script from "./MoleculeAddLicenseModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeAddLicenseModal.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeAddLicenseModal.vue?vue&type=style&index=0&id=2b8e78d2&lang=css"

const __exports__ = script;

export default __exports__